import {
  ADMIN_ROLES,
  CUSTOMER_CARE_ROLES,
  LOUNGE_STAFF_ROLES,
  OFFICE_HEAD_ROLES,
} from '@constants/roles';

export interface NavLinkItem {
  href: string;
  title: string;
}

export const getNavLinks = (role: string): NavLinkItem[] => {
  const officeHeadLinks: NavLinkItem[] = OFFICE_HEAD_ROLES.includes(role)
    ? [
        { href: '/', title: 'Home' },
        { href: '/client', title: 'Clients' },
        { href: '/lounges', title: 'Lounges' },
        { href: '/lounge-groups', title: 'Lounge Groups' },
        { href: '/devices', title: 'Devices' },
        { href: '/card-category', title: 'Card Category' },
        { href: '/bin-search', title: 'BINs' },
        // Admin-only for now; more roles may be allowed later
        ...(ADMIN_ROLES.includes(role)
          ? [{ href: '/bin-ingestion', title: 'BINs Bulk Ingestion' }]
          : []),
        { href: '/eligibility-attempts', title: 'Eligibility Attempts' },
      ]
    : [];

  const adminLinks: NavLinkItem[] = ADMIN_ROLES.includes(role)
    ? [
        { href: '/reports', title: 'Reports' },
        { href: '/users', title: 'Users' },
      ]
    : [];

  const customerCareLinks: NavLinkItem[] = CUSTOMER_CARE_ROLES.includes(role)
    ? [{ href: '/eligibility-attempts', title: 'Eligibility Attempts' }]
    : [];

  const loungeStaffLinks: NavLinkItem[] = LOUNGE_STAFF_ROLES.includes(role)
    ? [{ href: '/', title: 'Home' }]
    : [];

  return [
    ...officeHeadLinks,
    ...adminLinks,
    ...customerCareLinks,
    ...loungeStaffLinks,
  ];
};
